var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light-default rounded p-5",attrs:{"id":"service-container-app"},on:{"click":function($event){return _vm.openService(
      _vm.service.object_detail.slug,
      _vm.service.object_detail.id,
      _vm.service.object_detail.service_type,
      _vm.service.object_detail.name,
      _vm.service.object_detail.is_drug_testing,
      _vm.service.feature_type,
      _vm.service.object_detail.is_service_by_mail,
      _vm.service.object_detail.service_type_code,
      _vm.service.object_detail.show_capture_method,
      _vm.service.object_detail.enable_ori_rate,
      _vm.service.object_detail.disable_pii,
      _vm.service.object_detail.enable_biometric_data_collection_disclosure
    )}}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"},[_c('div',{staticClass:"symbol-label",style:('background-size: contain;background-image: url(' +
            _vm.url +
            _vm.service.object_detail.image +
            ')')})]),_c('div',{staticClass:"d-flex flex-column flex-grow-1",staticStyle:{"min-height":"140px"}},[_c('a',{staticClass:"text-dark-cust font-weight-bolder font-size-lg text-hover-primary-cust mb-1"},[_vm._v(_vm._s(_vm.service.object_detail.name)),_c('span',{staticClass:"badge badge-secondary ml-5"},[_vm._v(_vm._s(_vm.service.object_detail.service_count))])]),_c('span',{staticClass:"text-dark-50 font-weight-normal font-size-sm"},[_vm._v(" "+_vm._s(_vm.service.object_detail.description)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }